export const ca = {
  'nav.ofertas': 'Ofertes',
  'nav.profesionales': 'Professionals',
  'nav.empresas': 'Empreses',
  'content.hubTitle': 'Actualitat i agenda',
  'content.hubSubtitle': 'Notícies, cursos i esdeveniments del sector. Tot el que necessites per estar al dia, en un mateix lloc.',
  'content.all': 'Tot', 'content.news': 'Notícies', 'content.training': 'Cursos', 'content.events': 'Esdeveniments',
  'content.filter': 'Filtrar contingut', 'content.search': 'Cercar notícies, cursos o esdeveniments…', 'content.readOnly': 'Selecció editorial',
  'content.viewAll': 'Veure actualitat i agenda',

  'nav.actualidad': 'Actualitat',
  'nav.formacion': 'Formació',
  'nav.eventos': 'Esdeveniments',
  'nav.forum': 'Fòrum',
  'nav.biblioteca': 'Biblioteca',
  'nav.colaboracion': 'Col·laboració',
  'nav.donaciones': 'Donacions',
  'nav.mercado': 'Mercat',
  'nav.login': 'Entrar',
  'nav.register': 'Crear compte',
  'nav.publish': 'Publicar oferta',
  'nav.search': 'Cercar',

  'hero.title': 'El punt de trobada professional de les arts escèniques',
  'hero.subtitle': 'Troba feina, professionals, empreses i oportunitats del sector tècnic.',
  'hero.searchPlaceholder': 'Tècnic d\'il·luminació, GrandMA3, rigging...',
  'hero.locationPlaceholder': 'Barcelona',
  'hero.searchWhat': 'Què estàs cercant?',
  'hero.searchButton': 'Cercar',
  'hero.quick.jobs': 'Cercar ofertes',
  'hero.quick.pros': 'Cercar professionals',
  'hero.quick.companies': 'Cercar empreses',

  'section.categories': 'Especialitats tècniques',
  'section.categories.sub': 'Troba professionals i ofertes per especialitat',
  'section.latestJobs': 'Últimes ofertes',
  'section.latestJobs.sub': 'Oportunitats recents del sector tècnic',
  'section.viewAll': 'Veure totes les ofertes',
  'section.pros': 'Troba professionals',
  'section.pros.sub': 'Cerca tècnics segons especialitat, experiència, ubicació, disponibilitat i coneixements tècnics.',
  'section.pros.cta': 'Cercar professionals',
  'section.companies': 'Empreses del sector',
  'section.companies.sub': 'Directori d\'empreses tècniques verificades',
  'section.companies.cta': 'Veure empreses',
  'section.news': 'Actualitat del sector',
  'section.news.sub': 'Notícies, tecnologia i tendències del backstage',
  'section.news.cta': 'Veure actualitat',
  'section.training': 'Formació',
  'section.training.sub': 'Cursos, certificacions i tallers del sector tècnic',
  'section.training.cta': 'Veure formació',
  'section.events': 'Esdeveniments del sector',
  'section.events.sub': 'Fires, congressos i trobades professionals',
  'section.events.cta': 'Veure esdeveniments',
  'section.stats': 'La realitat del sector',
  'section.stats.sub': 'Dades agregades de la comunitat Stage Crew',
  'section.stats.demoNote': 'Dades de mostra · S\'activaran amb dades reals',

  'cta.employer.title': 'Cerques personal tècnic?',
  'cta.employer.text': 'Publica la teva oferta i troba professionals del sector.',
  'cta.employer.button': 'Publicar una oferta',
  'cta.employer.note': 'Gratuït per començar',

  'badge.verified': 'Verificada',
  'badge.professionalPublished': 'Publicada per professional',
  'badge.substitution': 'Substitució',
  'badge.urgent': 'Urgent',
  'badge.available': 'Disponible',
  'badge.onTour': 'De bolos',
  'badge.demo': 'DEMO',

  'jobtype.trabajo': 'Feina',
  'jobtype.sustitucion': 'Substitució',
  'jobtype.refuerzo': 'Reforç',
  'jobtype.bolsa': 'Borsa de treball',
  'jobtype.urgente': 'Urgent',
  'jobtype.otro': 'Altre',

  'application.sent': 'Candidatura enviada',
  'application.withdraw': 'Retirar candidatura',
  'application.withdrawing': 'Retirant…',
  'application.withdrawSuccess': 'Candidatura retirada. Pots tornar-la a enviar mentre l’oferta continuï oberta.',
  'application.withdrawError': 'No s’ha pogut retirar la candidatura. Torna-ho a provar.',
  'application.withdrawHint': 'Torna a prémer per retirar la candidatura. Podràs tornar-t’hi a inscriure mentre l’oferta continuï oberta.',
  'application.closedHint': 'L’oferta està tancada. Contacta amb qui la va publicar si necessites comunicar un canvi.',

  'label.applicants': 'candidatures',
  'label.deadline': 'Data límit',
  'label.publishedBy': 'Publicada per',
  'label.location': 'Ubicació',
  'label.schedule': 'Horari',
  'label.compensation': 'Retribució',
  'label.skills': 'Habilitats tècniques',
  'label.experience': 'Experiència',
  'label.availability': 'Disponibilitat',
  'label.specialties': 'Especialitats',
  'label.activeJobs': 'ofertes actives',
  'label.rating': 'Valoració',
  'label.readMore': 'Llegir més',
  'label.viewOffer': 'Veure oferta',
  'label.viewProfile': 'Veure perfil',
  'label.viewCompany': 'Veure empresa',
  'label.viewDetails': 'Veure detalls',
  'label.date': 'Data',
  'label.category': 'Categoria',
  'label.source': 'Font',
  'label.modality': 'Modalitat',
  'label.price': 'Preu',
  'label.school': 'Escola',
  'label.sponsored': 'Patrocinat',
  'label.timeSlots': 'Franges horàries',
  'label.totalHours': 'Total d\'hores',
  'label.hoursShort': 'h',
  'label.phone': 'Telèfon',
  'label.certifications': 'Certificacions',

  'gate.title': 'Zona reservada als membres',
  'gate.subtitle': 'Uneix-te a STAGE CREW i gaudeix de tots els avantatges de la nostra comunitat. Crea el teu perfil gratuït i accedeix a totes les seves funcions.',
  'gate.login': 'Entrar',
  'gate.register': 'Crear compte gratuït',

  'profile.title': 'El meu perfil professional',
  'profile.subtitle': 'Completa la teva fitxa i decideix quina informació es mostra públicament. Els camps ocults mai es comparteixen amb altres usuaris.',
  'profile.section.public': 'Informació pública',
  'profile.section.contact': 'Contacte',
  'profile.section.skills': 'Habilitats i certificacions',
  'profile.section.privacy': 'Privacitat · què es mostra',
  'profile.visibility.on': 'Públic',
  'profile.visibility.off': 'Ocult',
  'profile.save': 'Desar canvis',
  'profile.saved': 'Canvis desats',
  'profile.error': 'No s\'ha pogut desar. Torna-ho a provar.',
  'profile.field.role': 'Càrrec / especialitat',
  'profile.field.category': 'Categoria',
  'profile.field.location': 'Ubicació',
  'profile.field.experience': 'Experiència',
  'profile.field.availability': 'Disponibilitat',
  'profile.field.bio': 'Bio professional',
  'profile.field.phone': 'Telèfon',
  'profile.field.email': 'Email de contacte',
  'profile.field.skills': 'Habilitats tècniques (separades per coma)',
  'profile.field.certifications': 'Certificacions (separades per coma)',
  'profile.myLink': 'El meu perfil',

  'footer.tagline': 'La comunitat professional de les arts escèniques',
  'footer.ofertas': 'Ofertes',
  'footer.profesionales': 'Professionals',
  'footer.empresas': 'Empreses',
  'footer.comunidad': 'Comunitat',
  'footer.stagecrew': 'Stage Crew',
  'footer.legal': 'Legal',
  'footer.allJobs': 'Totes les ofertes',
  'footer.searchPros': 'Cercar professionals',
  'footer.createProfile': 'Crear perfil',
  'footer.searchCompanies': 'Cercar empreses',
  'footer.registerCompany': 'Registrar empresa',
  'footer.publishJob': 'Publicar oferta',
  'footer.about': 'Sobre Stage Crew',
  'footer.contact': 'Contacte',
  'footer.collaborate': 'Col·labora',
  'footer.advertising': 'Publicitat',
  'footer.terms': 'Termes d\'ús',
  'footer.privacy': 'Privacitat',
  'footer.cookies': 'Cookies',
  'footer.copyright': '© 2026 Stage Crew · Tots els drets reservats',

  'auth.login.title': 'Benvingut de nou',
  'auth.login.subtitle': 'Accedeix al teu compte Stage Crew',
  'auth.register.title': 'Uneix-te a Stage Crew',
  'auth.register.subtitle': 'Crea el teu compte professional en menys d\'un minut',
  'auth.email': 'Correu electrònic',
  'auth.password': 'Contrasenya',
  'auth.name': 'Nom complet',
  'auth.accountType': 'Tipus de compte',
  'auth.accountPro': 'Professional',
  'auth.accountCompany': 'Empresa',
  'auth.submit.login': 'Entrar',
  'auth.submit.register': 'Crear compte',
  'auth.noAccount': 'No tens compte?',
  'auth.hasAccount': 'Ja tens compte?',
  'auth.demoNotice': 'Autenticació en mode demo — pendent de backend',

  'meta.filters': 'Filtres',
  'meta.results': 'resultats',
  'meta.sortBy': 'Ordenar per',
  'meta.newest': 'Més recents',
  'meta.oldest': 'Més antics',

  'empty.title': 'Sense resultats',
  'empty.subtitle': 'Prova ajustant els filtres de cerca',
};
